<template>
    <div>
        <Imagery/>
        <b-container>
            <b-row>
                <b-col>
                    <b-row>
                        <CTAs/>
                    </b-row>
                    <b-row>
                        <LocAndHour/>
                    </b-row>
                    <b-row>
                        <Amenities/>
                    </b-row>
                    <b-row>
                        <Reviews/>
                    </b-row>
                </b-col>
                <b-col cols="3">
                    <b-row>
                        <Telephone/>
                    </b-row>
                    <b-row>
                        <Claim/>
                    </b-row>
                </b-col>
            </b-row>
            <b-row>
                <CollectionsIncluding/>
            </b-row>
            <b-row>
                <OtherRecommendation/>
            </b-row>
            <b-row>
                <LinkHelper/>
            </b-row>
        </b-container>
        <Footer/>
    </div>
</template>

<style scoped>
.imagery {
    max-width: 100%;
}

.left {
    background: fuchsia;
}

.row2 {
    background: lemonchiffon;
    height: 300px;
}

.row3 {
    background: tomato;
    height: 300px;
}
</style>

<script>
import Imagery from '../components/place/Imagery'
import CTAs from '../components/place/CTAs'
import Telephone from '../components/place/Telephone'
import LocAndHour from '../components/place/LocAndHour'
import Claim from '../components/place/Claim'
import Amenities from '../components/place/Amenities'
import Reviews from '../components/place/Reviews'
import CollectionsIncluding from '../components/place/CollectionsIncluding'
import OtherRecommendation from '../components/place/OtherRecommendation'
import LinkHelper from '../components/place/LinkHelper'
import Footer from '../components/footer/Footer'

export default {
    components: {
        Imagery,
        CTAs,
        Telephone,
        LocAndHour,
        Claim,
        Amenities,
        Reviews,
        CollectionsIncluding,
        OtherRecommendation,
        LinkHelper,
        Footer
    },
    data() {
        return {

        }
    },
    methods: {

    },
    computed: {

    },
    mounted() {
        console.log('mounted')
        var placeId = this.$route.params.id
        console.log('placeId: ',placeId)
        // retrieve all place details
        this.$store.dispatch('retrievePlace', placeId)
    }

}
</script>